"use client"
import { useTheme } from "@/components/theme-provider"
import { useEffect, useState, useRef } from "react"

import { ScenicSwitch } from "@/components/scenic-switch"

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleThemeChange = (checked: boolean) => {
    if (timer.current) clearTimeout(timer.current)
    document.documentElement.classList.add("theme-transitioning")
    setTheme(checked ? "dark" : "light")
    timer.current = setTimeout(() => {
      document.documentElement.classList.remove("theme-transitioning")
      timer.current = null
    }, 280)
  }

  useEffect(() => {
    setMounted(true)
    return () => {
      if (timer.current) clearTimeout(timer.current)
      document.documentElement.classList.remove("theme-transitioning")
    }
  }, [])

  if (!mounted) {
    return <ScenicSwitch className="scenic-theme-toggle" aria-label="切换浅色或深色主题" />
  }

  return <ScenicSwitch
      checked={resolvedTheme === "dark"}
      onChange={handleThemeChange}
      className="scenic-theme-toggle"
      aria-label="切换浅色或深色主题"
    />
}
